import { render } from "./g-modal-slide.vue?vue&type=template&id=4b1d1406&ts=true"
import script from "./g-modal-slide.vue?vue&type=script&lang=tsx"
export * from "./g-modal-slide.vue?vue&type=script&lang=tsx"

import exportComponent from "D:\\Visual Studio\\Projects\\Web\\GGDev.Web.ThePortal\\GGDev.Web.ThePortal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__